/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { AuthStatusResponse } from '../models/AuthStatusResponse';
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';
export class AuthService {
    /**
     * Microsoft認証ページにリダイレクト
     * ユーザーをMicrosoft認証ページにリダイレクトします。
     * @returns any Successful Response
     * @throws ApiError
     */
    public static login(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/login',
        });
    }
    /**
     * 認証コールバック
     * Microsoft認証からのコールバックを処理し、トークンを取得します。
     * @param code
     * @param error
     * @returns any Successful Response
     * @throws ApiError
     */
    public static callback(
        code: string = '',
        error: string = '',
    ): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/callback',
            query: {
                'code': code,
                'error': error,
            },
            errors: {
                422: `Validation Error`,
            },
        });
    }
    /**
     * ログアウト処理
     * セッションをクリアしてログアウトします。
     * @returns any Successful Response
     * @throws ApiError
     */
    public static logout(): CancelablePromise<any> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/logout',
        });
    }
    /**
     * 認証状態を取得
     * 現在の認証状態とユーザー情報を返します。トークンの有効性も確認します。
     * @returns AuthStatusResponse Successful Response
     * @throws ApiError
     */
    public static status(): CancelablePromise<AuthStatusResponse> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/auth/status',
        });
    }
}
